import { environment } from "environments/environment";

export class ApiUrl {
    static usePermit=Boolean(JSON.parse(environment.usePermit));
    private static version = this.usePermit ?'v3':'v2';
    public static readonly companies = `${environment.apiUrl}/api/v3/Companies`;
    public static readonly invites = `${environment.apiUrl}/api/${ApiUrl.version}/Invites`;
    public static readonly resendinvites = `${environment.apiUrl}/api/${ApiUrl.version}/Invites/Send`;
    public static readonly apps = `${environment.apiUrl}/api/v2/Apps`;
    public static readonly usersV2 = `${environment.apiUrl}/api/v2/Users`;
    public static readonly usersV3 = `${environment.apiUrl}/api/v3/Users`;
    public static readonly profileV2 = `${environment.apiUrl}/api/v2/Profiles`;    
}